export const k3k3k3sanlianhao =  {
	balls:[
	   [-1,-1,-1,-1]
	],
    num:[
	   [123,234,345,456]
    ],
    views:[
	   [123,234,345,456]
    ],
    titles: [
	  '三连号'
    ],
    getLottery:(num,balls)=>{
        let view = ""; 
        for(let i = 0;i < balls.length;i++){
		    for(let l = 0;l < balls[i].length;l++){
			    if(i == 0){
			    	if(balls[i][l] > 0){
					    view +=num[i][l]+"|"
				    }
			    }
		    }
    	}
	    return view.substring(0,view.length-1);
    },
    getNum:(balls)=>{
        let num = 0,arr = balls[0];
        for(let i=0,len=arr.length;i<len;i++){
            if(arr[i]>0){
                num++;
            }
        }
        return num;
    },
    getView: (views,balls)=>{
        let view = ""; 
        for(let i = 0;i < balls.length;i++){
		    for(let l = 0;l < balls[i].length;l++){
			    if(i == 0){
			    	if(balls[i][l] > 0){
					    view +=views[i][l]+"|"
				    }
			    }
		    }
    	}
	    return view.substring(0,view.length-1);
    }
}
